import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Table, TableBody, TableRow, TableCell } from '@material-ui/core'
import SydLabel from '../../../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../../../commonDesign/SydInput'
import SydSwitch from '../../../../../../../commonDesign/SydSwitch'
import { blueprintExportFormats } from '../../../../../../../organisms/QueryBlueprint/admin/blueprintExportFormats'

function ExportSettingsEditor ({ localConfig, setLocalConfig }) {
  return (
    <Grid item xs={12}>
      <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <h4 style={{ margin: 0 }}>Export Settings</h4>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
        <SydSwitch
          value={!!localConfig.export?.enabled}
          onChange={(e, enabled) => setLocalConfig(prev => ({
            ...prev,
            export: enabled
              ? { ...prev.export, enabled: true, formats: prev.export?.formats || ['csv'] }
              : { ...prev.export, enabled: false }
          }))}
        />
        <span style={{ fontSize: '0.875rem' }}>Enable Export</span>
      </div>

      {localConfig.export?.enabled
        ? (
          <>
            <p style={{ fontSize: '0.875rem', color: 'var(--text-color-subtle)', marginTop: 0, marginBottom: '12px' }}>
              Select which export formats are available to end users.
            </p>
            <Table className='opal-presentation-table zebra-rows' size='small' style={{ marginBottom: '16px' }}>
              <TableBody className='opt-tbody'>
                {blueprintExportFormats.map(fmt => (
                  <TableRow className='opt-tr' key={fmt.key}>
                    <TableCell className='opt-td' style={{ width: '48px' }}>
                      <SydSwitch
                        value={(localConfig.export?.formats || []).includes(fmt.key)}
                        onChange={(e, checked) => {
                          setLocalConfig(prev => {
                            const current = prev.export?.formats || []
                            const formats = checked
                              ? [...current, fmt.key]
                              : current.filter(f => f !== fmt.key)
                            if (!formats.length) {
                              return { ...prev, export: { ...prev.export, enabled: false, formats } }
                            }
                            return { ...prev, export: { ...prev.export, formats } }
                          })
                        }}
                      />
                    </TableCell>
                    <TableCell className='opt-td'>{fmt.label}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <SydLabel label='Default File Name' helperText='Pre-filled name when users export (optional)'>
              <SydInput
                value={localConfig.export?.defaultFileName || ''}
                onChange={(e) => setLocalConfig(prev => ({
                  ...prev,
                  export: { ...prev.export, defaultFileName: e.target.value || undefined }
                }))}
                placeholder='blueprint-export'
              />
            </SydLabel>
          </>
        )
        : null}
    </Grid>
  )
}

ExportSettingsEditor.propTypes = {
  localConfig: PropTypes.object.isRequired,
  setLocalConfig: PropTypes.func.isRequired
}

export default ExportSettingsEditor
